import React, { useState, useEffect } from "react";
import { getYoutubePosterImage, getRouting } from "../../../../../utils/common";
import "../style.scss";
import "./style.scss";
import { Helmet } from "react-helmet";
import ReactPlayer from "react-player";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getMarketVideoDetail } from "../actions";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";

const VideoDetail = (props) => {
  const {
    getMarketVideoDetail,
    marketVideoDetail,
    location: { pathname },
  } = props;

  const currentDetail = pathname.split("/")[4];
  const [videoData, setVideoData] = useState();
  const [metaData, setmetaData] = useState();

  useEffect(()=>{
    getMarketVideoDetail({},currentDetail);
  },[currentDetail])

  useEffect(()=>{
    if(marketVideoDetail){
      setVideoData(marketVideoDetail);
    }
    if(marketVideoDetail && marketVideoDetail.meta){
      setmetaData(marketVideoDetail.meta)
    }
  },[marketVideoDetail])

  const handleChangeVideo = (e, item) => {
    getMarketVideoDetail({},item.suggestedUrl);
  };

  useEffect(() => {
    if (videoData) {
      window.scrollTo(0, 0);
    }
  }, [videoData]);

  return (
    <div className="wrapper">
      {metaData && metaData !== null && <Helmet>
        <title>{metaData.title ? metaData.title : ""}</title>
        <meta name="description" content={metaData.description ? metaData.description : ""} />
        <meta name="keywords" content={metaData.keywords ? metaData.keywords : ""} />
        <meta property="og:title" content={metaData.og_title ? metaData.og_title : ""} />
        <meta property="og:description" content={metaData.og_description ? metaData.og_description : ""} />
        <meta property="og:image" content={metaData.og_image ? metaData.og_image : ""} />
        <meta property="og:url" content={metaData.og_url ? metaData.og_url : ""} />
      </Helmet>}
      <section className="aboutHead">
        <div className="container">
          <div className="d-flex dropdowncls">
            <div className="me-auto">
              <div>
                <h1>
                  <span>Videos</span>
                </h1>
              </div>
            </div>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={getRouting(`/`)}>Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={getRouting(`/investor-services/market-update/videos`)}>
                    Market Update
                  </Link>
                </li>
                <li className="breadcrumb-item active breadcolor" aria-current="page">
                  Videos
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="row mb-5 mt-5">
            <div className="col-md-7 videosec mb-4">
              <ReactPlayer
                url={
                  videoData &&
                  videoData.video &&
                  videoData.video.sources &&
                  videoData.video.sources[0] &&
                  videoData.video.sources[0].src ? 
                  videoData.video.sources[0].src :
                    `https://www.youtube.com/watch?v=${videoData && videoData.youtubeId}`
                
                }
                controls="true"
                className="videoplayer"
                muted={true}
                playing={true}
              />
              <div className="defaultVideoDetails">
                <h2>
                  {videoData && videoData.title
                    ? videoData.title
                    : ""}
                </h2>
                <p className="">
                  {videoData && videoData.description ?  <div dangerouslySetInnerHTML={{ __html: videoData.description }} />:''}
                </p>
              </div>
            </div>
            <div className="col-md-5 videosecright mb-4">
              {videoData &&
              videoData.otherVideo &&
                videoData.otherVideo.length > 0 &&
                videoData.otherVideo.map((item) => {
                    const posterImage = getYoutubePosterImage(item.youtubeId);
                    return (
                      <Link
                        to={getRouting(
                          `/investor-services/market-update/videos/${item.suggestedUrl ? item.suggestedUrl : ''}`
                        )}
                      >
                        <div className="row mb-3">
                          <div className="col-6">
                            <a
                              href="javascript:void(0)"
                              onClick={(e) => handleChangeVideo(e, item)}
                            >
                              <div className="mainvideo">
                                {item && item.thumbnail && item.thumbnail.url ?
                                  <img
                                  src={item.thumbnail.url}
                                  className="w-100 imgh webinarvideo"
                                  />
                                :
                                <>
                                {!posterImage ? (
                                  <img
                                    src="/images/New/learnNew/articlesimg.svg"
                                    className="w-100 imgh webinarvideo"
                                  />
                                ) : (
                                  <img
                                    src={posterImage}
                                    className="w-100 imgh webinarvideo"
                                  />
                                )}
                                 </>
                                }
                                <img
                                  src="/images/New/learnNew/you-tube-play-icon.png"
                                  className="playicon"
                                />
                               
                                {item.videoDuration ? (
                                  <div className="readcls">
                                    {item.videoDuration}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </a>
                          </div>

                          <div className="col-6">
                            <a
                              href="javascript:void(0)"
                              onClick={(e) => handleChangeVideo(e, item)}
                              className="leftVideoTitle"
                            >
                              <h3>
                                {item.title ? item.title : ""}
                              </h3>
                              <p className="">
                                {item.description ? <div dangerouslySetInnerHTML={{ __html: item.description }} /> : ''}
                              </p>
                            </a>
                          </div>
                        </div>
                      </Link>
                    );
                  })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  marketVideoDetail: state.InvesterServices.marketVideoDetailData,
});

const mapDispatchToProps = (dispatch) => ({
  getMarketVideoDetail: bindActionCreators(getMarketVideoDetail, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoDetail);

